/** Enhance native disclosures without intercepting navigation, contact or search. */
class LoraSharedHeader extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.disclosures = [...this.querySelectorAll('[data-header-disclosure]')];
    this.querySelectorAll('[data-header-close]').forEach(button => { button.hidden = false; });
    this.disclosures.forEach(disclosure => {
      const summary = disclosure.querySelector('summary');
      summary.setAttribute('aria-expanded', String(disclosure.open));
      disclosure.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(disclosure.open));
        if (disclosure.open) this.disclosures.forEach(other => { if (other !== disclosure) this.close(other); });
      }, options);
    });
    this.addEventListener('click', event => {
      const closeButton = event.target.closest('[data-header-close]');
      if (closeButton) this.close(closeButton.closest('[data-header-disclosure]'), true);
      const summary = event.target.closest('summary');
      if (summary?.parentElement.matches('[data-header-disclosure]')) {
        this.disclosures.forEach(other => { if (other !== summary.parentElement) this.close(other); });
      }
    }, options);
    this.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const open = this.disclosures.find(disclosure => disclosure.open);
      if (!open) return;
      event.preventDefault();
      this.close(open, true);
    }, options);
    document.addEventListener('pointerdown', event => {
      if (!this.contains(event.target)) this.disclosures.forEach(disclosure => this.close(disclosure));
    }, options);
    document.addEventListener('focusin', event => {
      if (!this.contains(event.target)) this.disclosures.forEach(disclosure => this.close(disclosure));
    }, options);
  }
  close(disclosure, restoreFocus = false) {
    if (!disclosure?.open) return;
    disclosure.open = false;
    const summary = disclosure.querySelector('summary');
    summary.setAttribute('aria-expanded', 'false');
    if (restoreFocus) summary.focus();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('lora-shared-header')) customElements.define('lora-shared-header', LoraSharedHeader);
